<template>
    <small v-if="product.is_nos"></small>
    <small v-else-if="product.availability.quantity > 0"><span>{{ $t('models.ProductStock.availability')}}</span>: {{product.availability.quantity}}</small>
</template>

<script>
export default {
    props: [
        'product',
    ],
};
</script>
